import React, { useState } from "react"
import Svg from "../_svgs/svg"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"

export default function LanguageSelector({ languages, useParkingLanguageSelection, languageChoiceLabel }) {
  const [isLanguageActive, setIsLanguageActive] = useState(false)

  const handleLanguageToggle = () => {
    setIsLanguageActive(!isLanguageActive)
  }

  return languages && languages.length > 0 ? (
    <div className={`main-navigation__item langselect js--has-dropdown ${isLanguageActive ? "is-dropped" : ""}`}>
      <OutsideClickTrigger onOutsideClick={() => setIsLanguageActive(false)}>
        <>
          {languages.map((lang, index) => {
            if (lang.selected) {
              return (
                <button key={index} className="button button--nav js--dropdown-trigger" onClick={() => handleLanguageToggle()}>
                  <img src={lang.languageLogo}></img>
                  <Svg iconName={"arrowdownangle"} />
                </button>
              )
            }
            return
          })}

          <div className={`dropdown dropdown--language ${isLanguageActive ? "is-active" : ""}`}>
            {languageChoiceLabel ? <h6>{languageChoiceLabel}</h6> : ""}
            <ul className="dropdown__list js--dropdown-list" data-dropdowntargetid={2}>
              {useParkingLanguageSelection
                ? languages.map((lang, index) => {
                    if (!lang.selected) {
                      return (
                        <li key={index} className="dropdown__item">
                          <a tabIndex={isLanguageActive ? 0 : -1} className={`button ${lang.selected ? "is-active" : ""}`}>
                            <img src={lang.languageLogo}></img>
                            <span className="langtext">{lang.text}</span>
                          </a>
                        </li>
                      )
                    }
                  })
                : languages.map((lang, index) => {
                    if (!lang.selected) {
                      return (
                        <li key={index} className="dropdown__item">
                          <a tabIndex={isLanguageActive ? 0 : -1} href={lang.value} className={`button ${lang.selected ? "is-active" : ""}`}>
                            <img src={lang.languageLogo}></img>
                            <span className="langtext">{lang.text}</span>
                          </a>
                        </li>
                      )
                    }
                  })}
            </ul>
          </div>
        </>
      </OutsideClickTrigger>
    </div>
  ) : (
    ""
  )
}
